@if (!isEmbedded) {
  <div class="file-upload-preview" [ngClass]="{'ccu-file-upload-preview': isCCU}">
    @if (fileUploadType == 'image' && imageUrl) {
      <div>
        <div class="image-upload-container">
          <img [src]="imageUrl" alt="Image preview">
          <div class="image-upload-icon">
            <svg (click)="onResetFileUpload($event)" width="13" height="12" viewBox="0 0 13 12" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.82594 5.98349L12.0755 9.2655C12.4979 9.65544 12.4979 10.3053 12.0755 10.6953L11.3606 11.4102C10.9706 11.8326 10.3207 11.8326 9.93078 11.4102L6.68126 8.16066L3.39925 11.4102C3.00931 11.8326 2.35941 11.8326 1.96947 11.4102L1.25457 10.6953C0.832135 10.3053 0.832135 9.65544 1.25457 9.2655L4.50409 5.98349L1.25457 2.73397C0.832135 2.34403 0.832135 1.69412 1.25457 1.30418L1.96947 0.589289C2.35941 0.166852 3.00931 0.166852 3.39925 0.589289L6.68126 3.83881L9.93078 0.589289C10.3207 0.166852 10.9706 0.166852 11.3606 0.589289L12.0755 1.30418C12.4979 1.69412 12.4979 2.34403 12.0755 2.73397L8.82594 5.98349Z"
                fill="currentColor" />
            </svg>
          </div>
        </div>
        <!-- Displaying upload options for image upload -->
        <ng-container *ngTemplateOutlet="uploadOptionsTemplate"></ng-container>
      </div>
    }
    @if ((fileUploadType == 'file' || fileUploadType == 'pdf') && selectedFile) {
      <div>
        <span class="file-upload-container">
          <span class="file-upload-label">{{selectedFile.name}}</span>
          <svg (click)="onResetFileUpload($event)" class="file-attachment-icon" width="32" height="32"
            viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.9676 9.38809C20.4359 8.91975 21.2624 8.91975 21.7307 9.38809L22.6123 10.2697C23.1082 10.7656 23.0807 11.5645 22.6123 12.0329L18.6452 16L22.6123 19.9671C23.1082 20.463 23.0807 21.262 22.6123 21.7303L21.7307 22.6119C21.2349 23.1078 20.4635 23.1078 19.9676 22.6119L16.0004 18.6448L12.0333 22.6119C11.5374 23.1078 10.766 23.1078 10.2701 22.6119L9.38852 21.7303C8.92018 21.262 8.89263 20.463 9.38852 19.9671L13.3557 16L9.38852 12.0329C8.92018 11.5645 8.89263 10.7656 9.38852 10.2697L10.2701 9.38809C10.7385 8.91975 11.5649 8.91975 12.0333 9.38809L16.0004 13.3552L19.9676 9.38809Z"
              fill="currentColor" />
          </svg>
        </span>
        <!-- Displaying upload options for file/pdf upload -->
        <ng-container *ngTemplateOutlet="uploadOptionsTemplate"></ng-container>
      </div>
    }
    <div [hidden]="!showUploadOptions || isMobileApp" class="upload-options-dialog">
      <div class="upload-options">
        <div (click)="onOpenCameraDialog()" class="upload-option">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M25.4545 12V22.2857C25.4545 23.25 24.642 24 23.6818 24H8.31814C7.32098 24 6.54541 23.25 6.54541 22.2857V12C6.54541 11.0714 7.32098 10.2857 8.31814 10.2857H11.5681L12.0113 9.14286C12.2698 8.46429 12.9346 8 13.6733 8H18.2897C19.0284 8 19.6931 8.46429 19.9517 9.14286L20.4318 10.2857H23.6818C24.642 10.2857 25.4545 11.0714 25.4545 12ZM20.4318 17.1429C20.4318 14.7857 18.4375 12.8571 16 12.8571C13.5255 12.8571 11.5681 14.7857 11.5681 17.1429C11.5681 19.5357 13.5255 21.4286 16 21.4286C18.4375 21.4286 20.4318 19.5357 20.4318 17.1429ZM19.25 17.1429C19.25 18.8929 17.7727 20.2857 16 20.2857C14.1903 20.2857 12.75 18.8929 12.75 17.1429C12.75 15.4286 14.1903 14 16 14C17.7727 14 19.25 15.4286 19.25 17.1429Z"
              fill="currentColor" />
          </svg>
        </div>
        <div (click)="onUploadFile()" class="upload-option">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20.5587 10.3864C19.7753 9.60297 18.5038 9.60297 17.7204 10.3864L11.8126 16.2942C10.4609 17.6459 10.4609 19.8357 11.8126 21.1874C13.1644 22.5391 15.3541 22.5391 16.7058 21.1874L21.5862 16.307C21.9361 15.9571 22.5077 15.9571 22.8576 16.307C23.2076 16.657 23.2076 17.2285 22.8576 17.5785L17.9773 22.4588C15.9224 24.5137 12.596 24.5137 10.5412 22.4588C8.48628 20.404 8.48628 17.0776 10.5412 15.0227L16.449 9.11494C17.9355 7.62835 20.3436 7.62835 21.8302 9.11494C23.3168 10.6015 23.3168 13.0096 21.8302 14.4962L16.1793 20.1471C15.261 21.0654 13.7712 21.0654 12.8529 20.1471C11.9346 19.2288 11.9346 17.739 12.8529 16.8208L17.4764 12.1973C17.8264 11.8473 18.3979 11.8473 18.7479 12.1973C19.0978 12.5472 19.0978 13.1187 18.7479 13.4687L14.1244 18.0922C13.9092 18.3073 13.9092 18.6605 14.1244 18.8756C14.3395 19.0908 14.6927 19.0908 14.9078 18.8756L20.5587 13.2247C21.3421 12.4413 21.3421 11.1698 20.5587 10.3864Z"
              fill="currentColor" />
          </svg>
        </div>
      </div>
    </div>
  </div>
  <div class="chat-input" [ngClass]="{'ccu-chat-input': isCCU}">
    @if (uploadOptionsEnabled) {
      <div class="file-upload">
        <input [disabled]="disableInput" class="file-input" type="file" (change)="onFileSelected($event)" #fileUpload
          [attr.capture]="(isMobileApp && isAndroid) || isCCU ? 'environment' : null" />
        <button [disabled]="loading || disableInput" class="chat-button upload-button" (click)="onClickUpload('upload')">
          @if (!showUploadOptions) {
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.4807 14.1301C24.1431 14.1301 24.7275 14.7145 24.7275 15.3768V16.6236C24.7275 17.3249 24.1431 17.8704 23.4807 17.8704H17.8704V23.4807C17.8704 24.182 17.2859 24.7275 16.6236 24.7275H15.3768C14.6755 24.7275 14.1301 24.182 14.1301 23.4807V17.8704H8.5197C7.8184 17.8704 7.27295 17.3249 7.27295 16.6236V15.3768C7.27295 14.7145 7.8184 14.1301 8.5197 14.1301H14.1301V8.5197C14.1301 7.85736 14.6755 7.27295 15.3768 7.27295H16.6236C17.2859 7.27295 17.8704 7.85736 17.8704 8.5197V14.1301H23.4807Z"
                fill="currentColor" />
            </svg>
          }
          @if (showUploadOptions) {
            <svg width="32" height="32" viewBox="0 0 32 32" fill="upload-button"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.9676 9.38809C20.4359 8.91975 21.2624 8.91975 21.7307 9.38809L22.6123 10.2697C23.1082 10.7656 23.0807 11.5645 22.6123 12.0329L18.6452 16L22.6123 19.9671C23.1082 20.463 23.0807 21.262 22.6123 21.7303L21.7307 22.6119C21.2349 23.1078 20.4635 23.1078 19.9676 22.6119L16.0004 18.6448L12.0333 22.6119C11.5374 23.1078 10.766 23.1078 10.2701 22.6119L9.38852 21.7303C8.92018 21.262 8.89263 20.463 9.38852 19.9671L13.3557 16L9.38852 12.0329C8.92018 11.5645 8.89263 10.7656 9.38852 10.2697L10.2701 9.38809C10.7385 8.91975 11.5649 8.91975 12.0333 9.38809L16.0004 13.3552L19.9676 9.38809Z"
                fill="currentColor" />
            </svg>
          }
        </button>
      </div>
    }
    <div class="container" [ngClass]="{'container-with-send-icon': sendIconEnabled && isMobileApp}">
      @if (showPlaceholder) {
        <span class="input-placeholder" [ngClass]="{'input-placeholder-no-upload': !uploadOptionsEnabled, 'input-placeholder-occupant': isDarkTheme && !loading}">{{placeholder}}</span>
      }
      <div #inputElement [attr.contenteditable]="!disableInput" class="container-input notranslate"
        [ngClass]="{'input-disabled': (loading || disableInput), 'input-without-upload-icon': !uploadOptionsEnabled, 'container-input-occupant':isDarkTheme}" (input)="onInputChange($event)"
        (paste)="onPaste($event)" (keydown.enter)="onEnter($event)" (keyup)="onKeyUp($event)"
        (itemSelected)="addMention($event)" [mentionConfig]="mentionConfig" [mention]="mentionItems" [from]="isMobileApp ? 'mobile': isCCU ? 'ccu' : 'web'"
        [openMentionsMenu]="showMentionsMenu" (opened)="showMentionsMenu = false">
      </div>
    </div>
    @if (sendIconEnabled && (isMobileApp || isCCU)) {
      <div class="send-icon-container">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
          [ngClass]="{'disable-send-icon': disableInput || loading || !getInputText()}" (click)="sendMessage()">
          <path
            d="M7.29271 23.9175L8.767 17.533C8.8252 17.2613 9.05798 17.0479 9.34896 17.0091L17.5934 16.1552C17.8262 16.1358 17.8262 15.7865 17.5934 15.7477L9.34896 14.9521C9.05798 14.9327 8.8252 14.7192 8.767 14.4475L7.29271 8.08248C7.15691 7.53912 7.73887 7.09279 8.24324 7.34506L24.3635 15.4178C24.8485 15.6701 24.8485 16.3687 24.3635 16.621L8.24324 24.6549C7.73887 24.9072 7.15691 24.4608 7.29271 23.9175Z" />
        </svg>
      </div>
    }
    <!-- Camera Dialog -->
    @if (showCameraDialog) {
      <app-chat-camera-dialog [isMobileApp]="isMobileApp" (capture)="onCaptureImage($event)"
      (close)="onCloseCameraDialog()"></app-chat-camera-dialog>
    }
    <!-- Microphone -->
    @if (chatScreenConfig?.speechToTextEnabled) {
      <button (click)="onToggleMic()" class="chat-button mic-button" [disabled]="disableInput || loading"
        [ngClass]="{'mic-enabled': (micEnabled && (isMobileApp || isCCU)), 'with-send-icon': (sendIconEnabled && (isMobileApp || isCCU)), 'mic-button-portal': !(isMobileApp || isCCU)}"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"
          fill="none" [ngClass]="{'mic-disabled': disableInput || loading }">
          <path
            d="M16.1818 19.2727C17.9893 19.2727 19.4546 17.8075 19.4546 16V10.5454C19.4546 8.73793 17.9893 7.27271 16.1818 7.27271C14.3743 7.27271 12.9091 8.73793 12.9091 10.5454V16C12.9091 17.8075 14.3743 19.2727 16.1818 19.2727ZM21.6364 13.8182H21.0909C20.7896 13.8182 20.5455 14.0623 20.5455 14.3636V16C20.5455 18.55 18.3469 20.5961 15.7458 20.3425C13.4788 20.1212 11.8182 18.0833 11.8182 15.8057V14.3636C11.8182 14.0623 11.5741 13.8182 11.2727 13.8182H10.7273C10.4259 13.8182 10.1818 14.0623 10.1818 14.3636V15.7327C10.1818 18.7886 12.3626 21.5128 15.3636 21.9267V23.0909H13.4546C13.1532 23.0909 12.9091 23.335 12.9091 23.6363V24.1818C12.9091 24.4832 13.1532 24.7272 13.4546 24.7272H18.9091C19.2105 24.7272 19.4546 24.4832 19.4546 24.1818V23.6363C19.4546 23.335 19.2105 23.0909 18.9091 23.0909H17V21.9396C19.9219 21.5387 22.1818 19.0307 22.1818 16V14.3636C22.1818 14.0623 21.9377 13.8182 21.6364 13.8182Z"
            fill="currentColor" />
        </svg>
      </button>
    }
  </div>
}
@if (isEmbedded) {
  <div class="chat-input-embedded" [ngClass]="{'isInsideChartCommandPanel': isInsideChartCommandPanel}">
    <!-- Microphone -->
    <button (click)="onToggleMic()" class="chat-button-embedded" [disabled]="disableInput || loading"
      [ngClass]="{'mic-enabled': (micEnabled && isMobileApp), 'with-send-icon': (sendIconEnabled && (isMobileApp || isCCU))}"
      >
      <!-- Enabled -->
      <i class="fa fa-microphone microphone-default"  [ngClass]="{'microphone-active': micEnabled}"></i>
    </button>
    <div class="textarea-container">
      @if (!isInsideChartCommandPanel) {
        <textarea #inputElementText maxlength="1000" class="text-description-input notranslate"
          [ngClass]="{ 'input-disabled': (loading || disableInput) }" [disabled]="loading || disableInput"
          placeholder="Describe your chart" (input)="onInputChangeTextArea($event)" (keydown)="onKeyDown($event)"
        (keyup)="onKeyUp($event)" rows="1"></textarea>
      }
      @if (isInsideChartCommandPanel) {
        <textarea #inputElementText maxlength="1000" class="text-description-input notranslate"
          [ngClass]="{ 'input-disabled': (loading || disableInput) }" [disabled]="loading || disableInput"
          [placeholder]="placeholder" (input)="onInputChangeTextArea($event)"
        (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)" rows="1"></textarea>
      }
    </div>
    @if (sendIconEnabled && (isMobileApp || isEmbedded || isCCU)) {
      <div class="send-icon-container-embedded">
        @if (!isInsideChartCommandPanel) {
          <svg class="fill-send"
            [ngClass]="{'disable-send-icon': disableInput || loading || !getInputText()}" (click)="sendMessage()"
            width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.74396 16.5977L3.97254 11.2773C4.02104 11.0509 4.21503 10.873 4.45751 10.8407L11.3279 10.1291C11.5219 10.113 11.5219 9.82189 11.3279 9.78955L4.45751 9.12652C4.21503 9.11035 4.02104 8.93247 3.97254 8.70607L2.74396 3.40186C2.6308 2.94906 3.11577 2.57712 3.53607 2.78735L16.9696 9.51464C17.3738 9.72487 17.3738 10.307 16.9696 10.5173L3.53607 17.2122C3.11577 17.4224 2.6308 17.0505 2.74396 16.5977Z"
              />
          </svg>
        }
        @if (isInsideChartCommandPanel) {
          <svg class="fill-send"
            [ngClass]="{'disable-send-icon': disableInput || loading || !getInputText()}" (click)="sendMessage()"
            width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.01375 11.4433L1.02733 7.05397C1.06734 6.86719 1.22738 6.72044 1.42743 6.69375L7.09547 6.10673C7.25551 6.09339 7.25551 5.85325 7.09547 5.82656L1.42743 5.27957C1.22738 5.26622 1.06734 5.11947 1.02733 4.93269L0.01375 0.556718C-0.079606 0.183159 0.320491 -0.123693 0.667242 0.0497453L11.7499 5.59976C12.0834 5.7732 12.0834 6.25349 11.7499 6.42692L0.667242 11.9503C0.320491 12.1237 -0.079606 11.8168 0.01375 11.4433Z" />
          </svg>
        }
      </div>
    }
  </div>
}


<ng-template #uploadOptionsTemplate>
  <span class="file-upload-placeholder">{{fileUploadPlaceholder}}</span>
  @if (showUserInputOptions) {
    <div class="chat-options-container">
      @for (option of inputOptions; track option) {
        <div class="chat-option" (click)="onSelectOption(option)"
          matTooltip="{{option.description}}" matTooltipPosition="above"  [matTooltipClass]="isCCU ? ['chat-options-tooltip', 'ccu-tooltip'] : 'chat-options-tooltip'"
        [innerHTML]="getDisplayContent(option) | safeHtml"></div>
      }
    </div>
  }
</ng-template>
